/**
 * Auto-generated version file
 * Generated from git tag: v1.0.5-4-g13bfedb-dirty
 * DO NOT EDIT - This file is automatically generated during build
 */

export const UI_VERSION = 'v1.0.5-4-g13bfedb-dirty';
